/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Fedorov Maxim
 * @version 1.0.1
 * @since 1.0.1
 */

import IWidgetOrderInquiriesTranslation from '../../../types/pages/dashboard/widgetOrderInquiries';

const initTranslationOrderInquiries: IWidgetOrderInquiriesTranslation = {
    fail: {
        text: '',
    },
    inquiries: {
        empty: {
            btnText: '',
            helpText: '',
            title: '',
        },
        inquiriesLabel: '',
        successful: {
            btnText: '',
        },
    },
    order: {
        empty: {
            helpText: '',
            title: '',
        },
        orderLabel: '',
        successful: {
            btnText: '',
        },
    },
    title: '',
};

export default initTranslationOrderInquiries;
